export default __webpack_public_path__ + "static/media/willian_sunset.40b22a02.jpg";